export function clampMax(max: number, to = 2): number {
  return max < to ? to : max;
}
